import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=3dd96ced&scoped=true&lang=pug"
import script from "./toolbar.vue?vue&type=script&lang=ts"
export * from "./toolbar.vue?vue&type=script&lang=ts"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=3dd96ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd96ced",
  null
  
)

export default component.exports